import { NavLink } from 'react-router-dom'
import styles from './AppTabs.module.scss'

type TabSpec = {
  segment: string
  label: string
}

type AppTabsRouteProps = {
  /** e.g. `/role` or `/users` (no trailing slash) */
  basePath: string
  tabs: TabSpec[]
  /** Force selected tab for nested child screens (create/edit/view etc.). */
  activeSegment?: string
  className?: string
}

/**
 * Tab links to `${basePath}/${segment}` — active tab comes from the URL only.
 */
export function AppTabsRoute({ basePath, tabs, activeSegment, className }: AppTabsRouteProps) {
  const base = basePath.replace(/\/$/, '')

  return (
    <div className={`${styles.tabsWrapper} ${className ?? ''}`}>
      <nav className={styles.tabsList}>
        {tabs.map((tab) => (
          <NavLink
            key={tab.segment}
            to={`${base}/${tab.segment}`}
            className={({ isActive }) => {
              const active = activeSegment ? activeSegment === tab.segment : isActive
              return `${styles.tabsTrigger} ${styles.tabsTriggerLink} ${active ? styles.routerActive : ''}`
            }}
            end
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
    </div>
  )
}
